import React, { useState } from "react";

import { Form, Select, Button, Col, Row } from "antd";

import { v4 as uuidv4 } from "uuid";
import { bankAccounts } from "../../../../utils/NewPropertyHelper";

function BankAccounts() {
  const initialList = [
    {
      id: uuidv4(),
      cashGlAccount: "23291: Rental Income Account",
      accountType: "Operating Cash Account",
    },
    {
      id: uuidv4(),
      cashGlAccount: "23292: Security Deposit Bank Account",
      accountType: "Escrow Account",
    },
  ];

  const [accounts, setAccounts] = useState(initialList);

  function handleAddAccount() {
    const newList = accounts.concat({ id: uuidv4() });
    setAccounts(newList);
  }

  function handleRemoveAccount(id) {
    const newList = accounts.filter((item) => item.id !== id);
    setAccounts(newList);
  }

  return (
    <>
      <Row style={{ marginBottom: 8 }}>
        <Col className="tableHead" span={13}>
          <Form.Item required label="Cash GL Account"></Form.Item>
        </Col>
        <Col className="tableHead" span={10}>
          <Form.Item required label="Bank Account"></Form.Item>
        </Col>
        <Col span={1}></Col>
      </Row>

      <ul>
        {accounts.map((item, index) => (
          <li key={item.id}>
            <Row gutter={[8, 0]}>
              <Col span={13}>
                {index > 1 ? (
                  <Form.Item
                    name={`cashGlAccount${index}`}
                    rules={[
                      {
                        required: true,
                        message: "Please select cash GL Account",
                      },
                    ]}
                  >
                    <Select style={{ width: "100%" }} options={bankAccounts} />
                  </Form.Item>
                ) : (
                  <Form.Item name={`cashGlAccount${index}`}>
                    <p style={{ marginTop: "22px" }}>{item.cashGlAccount}</p>
                  </Form.Item>
                )}
              </Col>
              <Col span={10}>
                {accounts.length < 2 && (
                  <span
                    style={{
                      fontSize: "11px",
                      color: "GrayText",
                      marginLeft: "2px",
                    }}
                  >
                    {item.accountType}
                  </span>
                )}
                <Form.Item
                  name={`bankAccount${index}`}
                  rules={[
                    { required: true, message: "Please Select Bank Account" },
                  ]}
                >
                  <Select options={bankAccounts} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={1} style={{ display: index > 1 ? "block" : "none" }}>
                {accounts.length > 2 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      handleRemoveAccount(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </li>
        ))}
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={handleAddAccount}
          style={{ width: "100%" }}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Bank Account
        </Button>
      </ul>
    </>
  );
}

export default BankAccounts;
